<template>
  <FixedTooltip>
    <span :class="badgeClasses">
      <span :class="labelClasses">{{ name }}</span>
      <button
        v-if="removable"
        type="button"
        class="ml-0.5 rounded-full p-0 opacity-60 hover:opacity-100 focus:outline-none disabled:cursor-not-allowed disabled:opacity-40"
        :disabled="disabled"
        aria-label="Usuń specjalizację"
        @mousedown.prevent="$emit('remove', $event)"
      >
        ×
      </button>
    </span>
    <template #content>
      {{ tooltipText }}
    </template>
  </FixedTooltip>
</template>

<script setup>
import { computed } from 'vue';
import { specialisationBadgeClasses, specialisationBadgeTooltip } from '@/utils/specialisationBadge';
import FixedTooltip from '@/Shared/FixedTooltip.vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  siteContext: {
    type: String,
    default: null,
  },
  colorToken: {
    type: String,
    default: null,
  },
  removable: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'sm'].includes(value),
  },
});

defineEmits(['remove']);

const badgeClasses = computed(() => specialisationBadgeClasses({
  siteContext: props.siteContext,
  colorToken: props.colorToken,
  size: props.size,
}));

const labelClasses = computed(() => (
  props.size === 'sm' ? 'leading-[13px]' : 'leading-[16px]'
));

const tooltipText = computed(() => specialisationBadgeTooltip(
  props.colorToken || props.siteContext,
));
</script>
